export default __webpack_public_path__ + "static/media/popup.e409789a.jpeg";